if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const prevArrowHTML =
    `<button class="slick-prev slick-arrow" aria-label="Prev" type="button">
        <svg width="18" height="28" viewBox="0 0 18 28" fill="none" stroke="currentColor" stroke-width="4">
            <polyline points="18,0 2,14 18,28" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>`;
const nextArrowtHTML =
    `<button class="slick-next slick-arrow" aria-label="Next" type="button">
        <svg width="18" height="28" viewBox="0 0 18 28" fill="none" stroke="currentColor" stroke-width="4">
            <polyline points="0,0 16,14 0,28" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>`;

const slickOptions = {
    accessibility: false,
    prevArrow: prevArrowHTML,
    nextArrow: nextArrowtHTML
};


(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // WRAP SCORECARD TABLE
    document.querySelectorAll('.scorecardsModule_item table').forEach(table => {
        const tableWrapper = document.createElement('div');
        tableWrapper.classList.add('scorecardsModule_table');
        table.parentNode.insertBefore(tableWrapper, table);
        tableWrapper.appendChild(table);
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    // SLICK
    $('.sym-slides').slick( slickOptions );

    $('.js-slick-prev').click(function(){
        $(this).closest('.sym-slides').slick('slickPrev');
    });
    $('.js-slick-next').click(function(){
        $(this).closest('.sym-slides').slick('slickNext');
    });

    $("#id_7_95").change(function() {
        var optionValue = $(this).val();
        console.log(optionValue);
        var Property_sendTo = $("input#sendto_95");
        switch (optionValue) {
            case "Hanbury Manor":
                console.log( "Hanbury Manor" );
                Property_sendTo.val("adam.lapwood@marriott.com");
                break;
            default:
                Property_sendTo.val("Countryclubs.Golf@marriott.co.uk");
                console.log( "default" );
                break;
        }
    });

    $( ".active-check-listener" ).on( "click", function(){

        setTimeout( function(){

            $("#id_9_95").datepicker("setDate", new Date());
            $( ".fancybox-inner .field.gdpr:eq(0) label, .fancybox-inner .field.gdpr:eq(1) label" ).on( "click", function(){
                $( this ).toggleClass( "selected" );

                if( $( this ).hasClass( "selected" ) ){
                    $( this ).prev().attr( "checked", "checked" );
                }else{
                    $( this ).prev().removeAttr( "checked" );
                }

            } )

        }, 2000 )

    } )

    var current_url = document.URL;
    current_url = current_url.split( "/" )[4];
    $( ".our-clubs .btn-link .link" ).attr( "href", "/scorecards#" + current_url )

    var current_url_scorecards = document.URL;
    current_url_scorecards = current_url_scorecards.split( "#" )[1];

    var showed_articule = false;

    $( "#scorecardsModule_drop-8353 option" ).each( function(){

        if( showed_articule )
            return;

        var _this = this;
        var current_val = $( this ).val();
        current_val = current_val.replaceAll( " ", "-" );
        current_val = current_val.replaceAll( ".", "" );
        current_val = current_val.toLowerCase();

        if( current_val == current_url_scorecards ){

            $( "#scorecardsModule_drop-8353" ).val( $( this ).val() );
            $( "#scorecardsModule_drop-8353" ).attr( "value", $( this ).val() );
            $( this ).attr( "selected", "selected" )

            $( ".scorecardsModule_list article" ).removeClass("active");
            $( ".scorecardsModule_list article" ).each( function(){

                if( $( this ).data( "tags" ) == $( _this ).val() ){
                    $( this ).addClass( "active" );
                    showed_articule = true;
                }

            } )

            setTimeout( function(){
                $( "#scorecardsModule_drop-8353" ).trigger('change');
            }, 2000 )

        }


    } )
    console.log('HERE');

})();

setInterval( function(){
    var inputs = $( "input[name=date_of_event]" );
    inputs = inputs[1];
    $( inputs ).val( $( "#id_9_95" ).val() )
}, 1000 )

/**
 * This method is used close fancybox
 *
 * @param   {array}  data  all fields of form
 */
 function eventSubmit(data){
	$.fancybox.close();
}


if (document.querySelector('.js-booking-btn')) {
    const Sites = {
        breadsall: { 
            url: 'https://book.breadsallpriory.marriottlifestyle.co.uk/golf', 
            phone: '+44(0)1332 836001', 
            membershipMail: 'mhrs.emags.golf@deltahotels.com', 
            formId: 'breadsall-form' },
        forest: { 
            url: 'https://book.forestofarden.marriottlifestyle.co.uk/golff', 
            phone: '+44(0)1332 836001', 
            membershipMail: '', 
            formId: 'forest-form' },
        hanbury: { 
            url: 'https://book.hanburymanor.marriottlifestyle.co.uk/golf', 
            phone: '+44(0)1332 836001', 
            membershipMail: 'hanburymanor.events@marriotthotels.co.uk', 
            formId: 'hanbury-form' },
        stpierre: { 
            url: 'https://book.stpierre.marriottlifestyle.co.uk/golf', 
            phone: '+44(0)1332 836001',
            membershipMail: 'Dhr.brssp.leisure@deltahotels.com', 
            formId: 'stpierre-form' },
        worsley: { 
            url: 'https://book.worsleypark.marriottlifestyle.co.uk/golf', 
            phone: '+44(0)1332 836001', 
            membershipMail: 'dhr.manwp.golf@deltahotels.com', 
            formId: 'worsley-form' },
        tudor: { 
            url: 'https://book.tudorpark.marriottlifestyle.co.uk/golf', 
            phone: '+44(0)1332 836001', 
            membershipMail: 'Dhr.lontp.golf@deltahotels.com', 
            formId: 'tudor-form' }
    };

    const bookingBtn = document.querySelector('.js-booking-btn');
    const widgetBox = document.querySelector('.booking_reservation_box');
    const locationSelect = document.querySelector('.booking_reservation_box select#location');
    const bookingTypeBox = document.querySelector('.booking_type_box');
    const resultsBox = document.querySelector('.booking_results_box');
    const formsBox = document.querySelector('.booking_forms_box');

    bookingBtn.addEventListener('click', (e) => {
        hideWidgets();
        e.preventDefault();
        widgetBox.classList.toggle('hidden');
    });

    if (locationSelect) {
        locationSelect.addEventListener('change', () => {
            const property = locationSelect.value;
            const { url, membershipMail, phone, formId } = Sites[property] || {};

            if (url && phone && formId || membershipMail ) {
                showSecondWidget();
                updateSecondWidget({ link: url, email: membershipMail, phone, formId });
            }
        });
    }

    if( document.querySelectorAll('.js-close-icon') ) {
        let closeBtnCollection = document.querySelectorAll('.js-close-icon');
        closeBtnCollection.forEach( btn => {
            btn.addEventListener('click', () => {
                hideWidgets()
            })
        })
    }

    function hideWidgets() {
        hideElement(widgetBox);
        hideElement(bookingTypeBox);
        hideElement(resultsBox);
        hideFormsBox();
    }

    function hideElement(element) {
        element && element.classList.add('hidden');
    }

    function showSecondWidget() {
        bookingTypeBox.classList.remove('hidden');
    }

    function updateSecondWidget({ link, email, phone, formId }) {
        const teetimeBTN = document.querySelector('.booking_type_box .teetime a');
        teetimeBTN.href = link;

        const bookingPhoneBtn = document.querySelector('.booking_type_box .golf_breaks');
        bookingPhoneBtn.addEventListener('click', () => {
            showResultsBox(phone, true, false);
        });

        const bookingFormBtn = document.querySelector('.booking_type_box .group_bookings');
        bookingFormBtn.addEventListener('click', () => {
            hideWidgets();
            showFormsBox(formId);
        });

        const bookingEmailBtn = document.querySelector('.booking_type_box .enquire');
        bookingEmailBtn.addEventListener('click', () => {
            showResultsBox(email, false, true);
        });

        bookingEmailBtn.setAttribute('data-mail', email);
    }

    function showResultsBox(content, showPhone, showEmail) {
        hideWidgets();
        const phoneBox = document.querySelector('.booking_results_box .phoneBox');
        const emailBox = document.querySelector('.booking_results_box .email-box');

        if (showPhone) {
            console.log({ showPhone, content });
            showElement(phoneBox);
            emailBox.classList.add('hidden');

            if( content ) {

                !phoneBox.querySelector('span').classList.contains('hidden')
                    ? phoneBox.querySelector('span').classList.add('hidden')
                    : null;

                phoneBox.querySelector('a').classList.contains('hidden')
                    ? phoneBox.querySelector('a').classList.remove('hidden')
                    : null;

                phoneBox.querySelector('a').href = `tel:${content}`;
                phoneBox.querySelector('a').textContent = content;

            } else {
                phoneBox.querySelector('a').classList.add('hidden');

                phoneBox.querySelector('span').classList.contains('hidden')
                    ? phoneBox.querySelector('span').classList.remove('hidden')
                    : null;
            }


            phoneBox.classList.contains('hidden')
                ? phoneBox.classList.remove('hidden')
                : null;



        } else if (showEmail) {

            console.log("========== EMAIL")
            showElement(emailBox);
            phoneBox.classList.add('hidden')

            if( content  ) {

                !emailBox.querySelector('span').classList.contains('hidden')
                    ? emailBox.querySelector('span').classList.add('hidden')
                    : null;

                emailBox.querySelector('a').classList.contains('hidden')
                    ? emailBox.querySelector('a').classList.remove('hidden')
                    : null;
                
                emailBox.querySelector('a').href = `mailto:${content}`;
                emailBox.querySelector('a').textContent = content;

            } else {

                emailBox.querySelector('a').classList.add('hidden');

                emailBox.querySelector('span').classList.contains('hidden')
                    ? emailBox.querySelector('span').classList.remove('hidden')
                    : null;
            }


            emailBox.classList.contains('hidden')
                ? emailBox.classList.remove('hidden') 
                : null;
        }

        resultsBox.classList.remove('hidden');
    }

    function showFormsBox(formId) {
        const form = document.querySelector(`#${formId}`);
        if (form) {
            showElement(formsBox);
            showElement(form);
        }
    }

    function showElement(element) {
        element && element.classList.remove('hidden');
    }

    function hideFormsBox() {
        hideElement(formsBox);
        formsBox && formsBox.querySelectorAll('.form').forEach((form) => hideElement(form));
    }
}
